import { handleClickToCopy } from "../../helpers/click-to-copy";

export const columnDefs = [
    {
        label: 'ID',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["id"])}
            title={"Click to copy"}
        >{item["id"]}</span>,
        resize: true,
        key: "id",
        width: "100px",
        select: true,
    },
    {
        label: 'Created At',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["created_at"])}
            title={"Click to copy"}
        >{item["created_at"]}</span>,
        resize: true,
        key: "created_at",
        width: "minmax(200px, 1fr)",
    },
    {
        label: 'Updated At',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["updated_at"])}
            title={"Click to copy"}
        >{item["updated_at"]}</span>,
        resize: true,
        key: "updated_at",
        width: "minmax(200px, 1fr)",
    },
    {
        label: 'AN Offer Name',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["an_offer_name"])}
            title={"Click to copy"}
        >{item["an_offer_name"]}</span>,
        resize: true,
        key: "an_offer_name",
        width: "minmax(350px, 1fr)",
    },
    {
        label: 'AN Offer ID',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["an_offer_id"])}
            title={"Click to copy"}
        >{item["an_offer_id"]}</span>,
        resize: true,
        key: "an_offer_id",
        width: "350px",
    },
    {
        label: 'AN Offer Link',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["an_offer_link"])}
            title={"Click to copy"}
        >{item["an_offer_link"]}</span>,
        resize: true,
        key: "an_offer_link",
        width: "350px",
    },
    {
        label: 'AN',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["an"])}
            title={"Click to copy"}
        >{item["an"]}</span>,
        resize: true,
        key: "an",
        width: "100px",
    },
    {
        label: 'Geo',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["geo"])}
            title={"Click to copy"}
        >{item["geo"]}</span>,
        resize: true,
        key: "geo",
        width: "100px",
    },
    {
        label: 'Status',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["status"])}
            title={"Click to copy"}
        >{item["status"]}</span>,
        resize: true,
        key: "status",
        width: "minmax(150px, 1fr)",
    },
    {
        label: 'Pack ID',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["pack_id"])}
            title={"Click to copy"}
        >{item["pack_id"]}</span>,
        resize: true,
        key: "pack_id",
        width: "400px",
    },
    {
        label: 'Priority',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["priority"])}
            title={"Click to copy"}
        >{item["priority"]}</span>,
        resize: true,
        key: "priority",
        width: "150px",
    },
    {
        label: 'Discovery ID',
        renderCell: (item) => <span
            className={"data-table-cell"}
            onClick={() => handleClickToCopy(item["discovery_id"])}
            title={"Click to copy"}
        >{item["discovery_id"]}</span>,
        resize: true,
        key: "discovery_id",
        width: "150px",
    },
];

export const rowsLimitOptions = [
    {value: "10", label: "10 / page"},
    {value: "50", label: "50 / page"},
    {value: "100", label: "100 / page"},
    {value: "500", label: "500 / page"},
];

export const orderDirectionOptions = [
    {value: "ASC", label: "Ascending"},
    {value: "DESC", label: "Descending"},
];

export const filterConditionOptions = [
    {value: "like", label: "Contains"},
    {value: "not like", label: "Not Contains"},
    {value: ">", label: "More than"},
    {value: "<", label: "Less than"},
    {value: "=", label: "Equal"},
    {value: "!=", label: "Not Equal"},
    {value: "in", label: "One of"},
]